
import ReactMarkdown from "react-markdown";

interface StandardContentRendererProps {
  content: string;
  isMarkdown: boolean;
  slug?: string;
}

/**
 * Standard content renderer for regular markdown or HTML content
 */
const StandardContentRenderer = ({ 
  content, 
  isMarkdown,
  slug 
}: StandardContentRendererProps) => {
  // Process markdown image paths if needed
  let processedContent = content;
  
  if (isMarkdown && slug === "user-behaviour-sequence-modelling") {
    // Replace image2.png with the provided CDN link specifically for the in-session article
    processedContent = processedContent.replace(
      /!\[([^\]]*)\]\(images\/image2\.png\)/g,
      `![$1](https://res.cloudinary.com/dvxgyuvxl/image/upload/v1746996336/image2_lcehai.png)`
    );
    
    // Fix other image paths in markdown content
    processedContent = processedContent.replace(
      /!\[([^\]]*)\]\(images\/([^)]+)\)/g, 
      (match, alt, imagePath) => {
        // Skip if we already replaced image2.png
        if (imagePath === "image2.png") return match;
        return `![${alt}](/html-content/images/${imagePath})`;
      }
    );
  } else if (isMarkdown) {
    // Fix image paths in markdown content for other articles
    processedContent = content.replace(
      /!\[([^\]]*)\]\(images\/([^)]+)\)/g, 
      (match, alt, imagePath) => {
        return `![${alt}](/html-content/images/${imagePath})`;
      }
    );
  }
  
  return isMarkdown ? (
    <ReactMarkdown>{processedContent}</ReactMarkdown>
  ) : (
    <div 
      dangerouslySetInnerHTML={{ __html: content }} 
      className="html-content"
    />
  );
};

export default StandardContentRenderer;
